import { Box, InputCheckBox, Text } from '@factorialco/deprecated-design-system'
import { difference } from 'lodash'

import i18n from 'modules/core/lib/i18n'
import type User from 'modules/core/store/models/User'

interface Props {
  disabled: boolean
  onSelectMultiple?: ((ids: number[]) => void) | null
  selectedIds: number[]
  users: User[]
  disabledIds?: number[]
}

export default function Controls({
  onSelectMultiple,
  users,
  selectedIds,
  disabled,
  disabledIds,
}: Props) {
  if (!onSelectMultiple) return null

  const userIds: number[] = difference(
    users.map((user) => user.attributes.id),
    disabledIds || []
  )

  const onSelectAll = () => {
    if (disabled) return

    if (!userIds.length) return onSelectMultiple(userIds)

    const selection = [...new Set([...selectedIds, ...userIds])]
    onSelectMultiple(selection)
  }

  const onSelectNone = () => {
    if (disabled) return

    onSelectMultiple(difference(selectedIds, userIds))
  }

  const selected = !difference(userIds, selectedIds).length
  const toggle = () => (selected ? onSelectNone() : onSelectAll())

  return (
    <Box
      alignItems="center"
      background="grey200"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
    >
      <InputCheckBox checked={selected} onClick={toggle} />
      <Text.Normal size="200" weight="medium">
        {i18n.t('common.name')}
      </Text.Normal>
    </Box>
  )
}
